import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import './app.scss'
import { EnvironmentOverlay } from './dashboard/layout/environmentOverlay/EnvironmentOverlay'
import { AppProviders } from './providers/AppProviders/AppProviders'
import { AppRoutes } from './routes/Routes'

export function App() {
  return (
    <AppProviders>
      <EnvironmentOverlay />
      <AppRoutes />
    </AppProviders>
  )
}
